"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/lib/store";
import { useLocaleStore } from "@/lib/hooks/useTranslation";

/**
 * Syncs the locale with the user's preference when authenticated.
 * This component should be placed in the root layout.
 */
export function LocaleSync() {
  const { user, isAuthenticated, _hasHydrated } = useAuthStore();
  const { setLocale } = useLocaleStore();

  useEffect(() => {
    // Wait for auth store to hydrate
    if (!_hasHydrated) return;

    // If user is authenticated and has a language preference, use it
    if (isAuthenticated && user?.ui_language) {
      setLocale(user.ui_language);
    }
  }, [_hasHydrated, isAuthenticated, user?.ui_language, setLocale]);

  return null;
}
